import { useMutation } from '@tanstack/react-query'

import { CriarAtendimentoService } from '@/http/criar-atendimento.service'
import type { TCriarAtendimentoBody, TCriarAtendimentoResponse } from '@/http/criar-atendimento.service'
import type { AxiosErrorMap } from '@/infra/http'
import { atendimentoKeys } from '@/utils/atendimento-query-keys'

export const useCriarAtendimento = () => {
  return useMutation<TCriarAtendimentoResponse, AxiosErrorMap, TCriarAtendimentoBody, unknown>({
    mutationKey: atendimentoKeys.criarAtendimento(),
    mutationFn: async ({ clienteId, codigoOportunidade }) =>
      new CriarAtendimentoService().execute({ clienteId, codigoOportunidade }),
  })
}
